let url = $(location).attr('href').split('/').splice(0, 5).join('/');
let segments = url.split('/');
let lang = segments[3];
let two_segment = segments[4];
if ('' === lang) {
	lang = 'ro';
}

let main_loader = `
<div class="loader_centered">
	<div class="dl">
		<div class="dl__container">
			<div class="dl__corner--top"></div>
			<div class="dl__corner--bottom"></div>
		</div>
		<div class="dl__square"></div>
	</div>
</div>
`;

$(document).ready(function () {
	//! Tabs
	const tabs = document.querySelectorAll('._tabs-item');
	tabs.forEach(tab => {
		tab.addEventListener('click', function (event) {
			const tabType = tab.getAttribute('data-tab');
			const url = new URL(window.location.href);
			if (tab.classList.contains('_active')) {
				url.searchParams.set('tab', tabType);
			} else {
				url.searchParams.delete('tab');
			}
			window.history.pushState({}, '', url);
		});
	});

	//! Catalog
	if ($('.catalog__container').length) {
		$(document).on(
			'click',
			'.pagging__arrow, .pagging__item',
			function (event) {
				event.preventDefault();
				let page = $(this).data('page');
				$('input[name=page]').val(page);
				reload_flt();
				window.scrollTo({
					top: 0,
					behavior: 'smooth',
				});
			}
		);

		$(document).on('click', '.load__more', function (event) {
			event.preventDefault();
			// Get data-page from button and update input field
			let nextPage = $(this).attr('data-page');
			$('input[name=page]').val(nextPage);
			load_more_products();
		});

		$(document).on('click', '.select__option', function (event) {
			event.preventDefault();
			let sort = $(this).data('value');
			$('input[name=page]').val(1);
			// $('input[name=sort]').val(sort);
			reload_flt();
		});
		$(document).on('change', 'input[name="department"]', function (event) {
			let department_id = $(this)
				.closest('label')
				.find('input[name="department"]:checked')
				.val();
			$('input[name=page]').val(1);
			reload_flt();
		});

		function load_more_products() {
			let ajax__table = $('.ajax__table').data('table');
			let loadMoreBtn = $('.load__more');

			let formData = $('form[name=catalog]').serialize();
			formData = formData.replace(/[^&]+=\.?(?:&|$)/g, '');

			// Disable button during loading
			loadMoreBtn.prop('disabled', true).text('Loading...');

			let searchParams = new URLSearchParams(window.location.search);
			let filteredParams = new URLSearchParams();
			for (let [key, value] of searchParams.entries()) {
				if (key.startsWith('search')) {
					filteredParams.append(key, value);
				}
			}
			let parameters = filteredParams.toString();
			if (formData) {
				if (parameters) {
					parameters += '&' + formData;
				} else {
					parameters = formData;
				}
			}
			if (parameters !== '') sign = '?';
			else sign = '';
			history.pushState(
				{},
				null,
				decodeURI(window.location.pathname + sign + parameters)
			);

			let url =
				window.location.pathname.replace(ajax__table, 'ajax_' + ajax__table) +
				'?' +
				parameters;

			$.get(url, function (response) {
				let data = JSON.parse(response);
				let $newContent = $(data.view);
				let $existingBody = $('.catalog__body');
				let $newBody = $newContent.find('.catalog__body');

				// Append new products to existing ones
				if ($newBody.length && $newBody.children().length > 0) {
					$existingBody.append($newBody.children());
				}

				// Update pagination footer
				let $existingFooter = $('.catalog__footer');
				let $newFooter = $newContent.find('.catalog__footer');
				if ($newFooter.length) {
					$existingFooter.replaceWith($newFooter);
				}

				// Check if there are more pages and update button
				let $newLoadMoreBtn = $('.load__more');
				if ($newLoadMoreBtn.length) {
					// Check if paginator has next page
					let hasNextPage =
						$('.pagging__arrow:last').not('._disabled').length > 0;
					if (hasNextPage) {
						// Get current page from input and calculate next page for button
						let currentPage = parseInt($('input[name=page]').val()) || 1;
						let nextNextPage = currentPage + 1;
						$newLoadMoreBtn.attr('data-page', nextNextPage);
						$newLoadMoreBtn.prop('disabled', false).text('Load more');
					} else {
						// No more pages, hide the button
						$newLoadMoreBtn.closest('.footer__buttons').hide();
					}
				} else {
					// Button doesn't exist in new content, hide the container
					$('.footer__buttons').hide();
				}

				attachQuantityButtonListeners();
			}).fail(function () {
				// Re-enable button on error
				loadMoreBtn.prop('disabled', false).text('Load more');
			});
		}

		function reload_flt() {
			let ajax__list = $('.ajax__list');
			let ajax__filters = $('.ajax__filters');
			let ajax__table = $('.ajax__table').data('table');
			let formData = $('form[name=catalog]').serialize();
			formData = formData.replace(/[^&]+=\.?(?:&|$)/g, '');

			$('.ajax__list').html(main_loader);

			let searchParams = new URLSearchParams(window.location.search);
			let filteredParams = new URLSearchParams();
			for (let [key, value] of searchParams.entries()) {
				if (key.startsWith('search')) {
					filteredParams.append(key, value);
				}
			}
			let parameters = filteredParams.toString();
			if (formData) {
				if (parameters) {
					parameters += '&' + formData;
				} else {
					parameters = formData;
				}
			}
			if (parameters !== '') sign = '?';
			else sign = '';
			history.pushState(
				{},
				null,
				decodeURI(window.location.pathname + sign + parameters)
			);
			ajax__list.css({
				opacity: 0.6,
			});
			let url =
				window.location.pathname.replace(ajax__table, 'ajax_' + ajax__table) +
				'?' +
				parameters;

			$.get(url, function (response) {
				let data = JSON.parse(response);
				ajax__list.replaceWith(data.view);
				// ajax__filters.replaceWith(data.filters);
				ajax__list.css({
					opacity: 1,
				});
				attachQuantityButtonListeners();
				return false;
			});
		}

		function attachQuantityButtonListeners() {
			let quantityContainers = document.querySelectorAll('.quantity');
			quantityContainers.forEach(container => {
				let newContainer = container.cloneNode(true);
				container.parentNode.replaceChild(newContainer, container);
			});

			let quantityButtons = document.querySelectorAll('.quantity__button');
			if (quantityButtons.length > 0) {
				for (let index = 0; index < quantityButtons.length; index++) {
					const quantityButton = quantityButtons[index];
					quantityButton.addEventListener('click', function (e) {
						let value = parseInt(
							quantityButton.closest('.quantity').querySelector('input').value
						);
						if (quantityButton.classList.contains('quantity__button_plus')) {
							value++;
						} else {
							value = value - 1;
							if (value < 1) {
								value = 1;
							}
						}
						quantityButton.closest('.quantity').querySelector('input').value =
							value;
					});
				}
			}
		}
	}

	//! Articles
	if ($('.articles-list').length) {
		$(document).on(
			'click',
			'.pagging__arrow, .pagging__item',
			function (event) {
				event.preventDefault();
				let page = $(this).data('page');
				$('input[name=page]').val(page);
				default_reload_flt();
				window.scrollTo({
					top: 0,
					behavior: 'smooth',
				});
			}
		);

		function default_reload_flt() {
			let ajax__list = $('.ajax__list');
			let ajax__table = $('.ajax__table').data('table');
			let formData = $('form[name=' + ajax__table + ']').serialize();
			formData = formData.replace(/[^&]+=\.?(?:&|$)/g, '');

			let searchParams = new URLSearchParams(window.location.search);
			let filteredParams = new URLSearchParams();
			for (let [key, value] of searchParams.entries()) {
				if (key.startsWith('search')) {
					filteredParams.append(key, value);
				}
			}
			let parameters = filteredParams.toString();
			if (formData) {
				if (parameters) {
					parameters += '&' + formData;
				} else {
					parameters = formData;
				}
			}
			if (parameters !== '') sign = '?';
			else sign = '';
			history.pushState(
				{},
				null,
				decodeURI(window.location.pathname + sign + parameters)
			);
			ajax__list.css({
				opacity: 0.6,
			});
			let url =
				window.location.pathname.replace(ajax__table, 'ajax_' + ajax__table) +
				'?' +
				parameters;
			$.get(url, function (response) {
				let data = JSON.parse(response);
				ajax__list.replaceWith(data.view);
				ajax__list.css({
					opacity: 1,
				});
				return false;
			});
		}
	}

	//! Orders
	if ($('.orders-list').length) {
		$(document).on(
			'click',
			'.pagging__arrow, .pagging__item',
			function (event) {
				event.preventDefault();
				let page = $(this).data('page');
				$('input[name=page]').val(page);

				console.log('page: ', page);

				default_reload_flt();
				window.scrollTo({
					top: 0,
					behavior: 'smooth',
				});
			}
		);

		function default_reload_flt() {
			let ajax__list = $('.ajax__list');
			let ajax__table = $('.ajax__table').data('table');
			let ajax__form = $('.ajax__table').data('form');
			let formData = $('form[name=' + ajax__form + ']').serialize();
			formData = formData.replace(/[^&]+=\.?(?:&|$)/g, '');

			let searchParams = new URLSearchParams(window.location.search);
			let filteredParams = new URLSearchParams();
			for (let [key, value] of searchParams.entries()) {
				if (key.startsWith('search')) {
					filteredParams.append(key, value);
				}
			}
			let parameters = filteredParams.toString();
			if (formData) {
				if (parameters) {
					parameters += '&' + formData;
				} else {
					parameters = formData;
				}
			}
			if (parameters !== '') sign = '?';
			else sign = '';
			history.pushState(
				{},
				null,
				decodeURI(window.location.pathname + sign + parameters)
			);
			ajax__list.css({
				opacity: 0.6,
			});
			let url =
				window.location.pathname.replace(ajax__table, 'ajax_' + ajax__table) +
				'?' +
				parameters;
			console.log('url: ', url);
			$.get(url, function (response) {
				let data = JSON.parse(response);
				ajax__list.replaceWith(data.view);
				ajax__list.css({
					opacity: 1,
				});
				return false;
			});
		}
	}

	//! Cart
	function header_cart() {
		$.ajax({
			url: '/' + lang + '/header_cart', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'html',
			data: { cart: 1 },
			success: function (data) {
				$('.header_cart_body').html(data);
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	}
	// Add to cart
	$('body').on('click', '.add_to_cart', function (e) {
		e.preventDefault();
		const _self = $(this);
		let type = _self.data('type');
		let product = _self.closest('.product__box');
		let id = product.data('id');
		let qty = product.find('.quantity__input input').val();
		if (type === 'checkbox') qty = 1;

		let max_qty = product.data('max_qty');
		let max_qty_error = product.data('max_qty_error');

		// Update product name in popup
		let title = product.find('.product__title').text();
		let productAddTemplate = $('.product__template').data('template');
		let productAdd = productAddTemplate.replace(/{n}/g, title);
		$('.product__template').text(productAdd);

		$.ajax({
			url: '/cart/add', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: {
				product_id: id,
				quantity: qty,
			},
			success: function (data) {
				if (data.status == 'ok') {
					$('.total_items_cart').html(data.total_items);
					header_cart();
					if (type === 'checkbox') location.reload();
				} else if (data.status == 'max_qty') {
					$('.total_items_cart').html(data.total_items);
					header_cart();
					if (type === 'checkbox') location.reload();
					let max_qty_alert = max_qty_error
						.replace(/{title}/g, title)
						.replace(/{max_qty}/g, max_qty);
					alert(max_qty_alert);
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
	// Remove from cart
	$('body').on('click', '.remove_from_cart', function (e) {
		e.preventDefault();
		const _self = $(this);
		let type = _self.data('type');
		let reload = _self.data('reload');
		let row_id = _self.data('row_id');

		// Confirm
		let confirmation = _self.data('confirmation');
		let confirmed = confirm(confirmation);
		if (!confirmed) return;

		$.ajax({
			url: '/cart/delete', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: { row_id: row_id },
			success: function (data) {
				if (data.status == 'ok') {
					if (reload) {
						location.reload();
					} else {
						$('.total_items_cart').html(data.total_items);
						header_cart();
					}
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
	// Remove all from cart
	$('body').on('click', '.remove_all_from_cart', function (e) {
		e.preventDefault();
		const _self = $(this);
		let reload = _self.data('reload');

		// Confirm
		let confirmation = _self.data('confirmation');
		let confirmed = confirm(confirmation);
		if (!confirmed) return;

		$.ajax({
			url: '/cart/delete_all', // путь к обработчику
			type: 'GET', // метод отправки,
			dataType: 'json',
			success: function (data) {
				if (data.status == 'ok') {
					if (reload) {
						location.reload();
					} else {
						$('.total_items_cart').html(data.total_items);
						header_cart();
					}
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
	// Update quantity
	$('body').on('click', '.update_item_qty', function (e) {
		e.preventDefault();
		const _self = $(this);
		let product = _self.closest('.product__box');
		let input = product.find('.quantity__input input');
		let product_id = product.data('id');
		let row_id = input.data('row_id');
		let cart_code = input.data('cart_code');
		let qty = input.val();

		let free = $('.delivery__total').data('free');
		let currency = $('.delivery__total').data('currency');
		let max_qty_error = input.data('max_qty_error');

		$.ajax({
			url: '/cart/update', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: {
				product_id: product_id,
				row_id: row_id,
				quantity: qty,
				cart_code: cart_code,
			},
			success: function (data) {
				if (data.status == 'ok') {
					$('.total_items_cart').html(data.total_items);
					header_cart();

					product.find('.item__total span').html(data.item_total);
					$('.products__total span').html(data.products_total);
					$('.discount__total span').html(data.discount_price);
					$('.cart__total span').html(data.cart_total);

					if (data.progress >= 100) {
						$('.delivery__total').html(free);
						$('.delivery__progress').css('width', data.progress + '%');
					} else {
						$('.delivery__total').html(data.delivery_price + ' ' + currency);
						$('.delivery__progress').css('width', data.progress + '%');
					}
				} else if (data.status == 'max_qty') {
					product.find('.quantity__input input').val(data.item_qty);

					let product_title = product.find('.product-cart__name').text().trim();
					let max_qty_alert = max_qty_error
						.replace(/{title}/g, product_title)
						.replace(/{max_qty}/g, data.item_qty);
					alert(max_qty_alert);
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});

	//! Files
	$('body').on('change', '.file__input', function (e) {
		e.preventDefault();
		const _self = $(this);
		const file = _self[0].files[0];
		if (file) {
			_self.closest('.file').find('.file__text').text(file.name);
			_self
				.closest('.login__form')
				.find('._btn_disabled')
				.removeClass('_btn_disabled')
				.removeAttr('disabled');
		}
	});
});